// extracted by mini-css-extract-plugin
export default {"skeleton":"Skeleton_skeleton__2IC2s","animate":"Skeleton_animate__9Ub5Q","shimmer":"Skeleton_shimmer__1CS1I","circle":"Skeleton_circle__sKMis","text":"Skeleton_text__dCyMj"};